export const FETCH_CREATE_COLUMN = 'FETCH_CREATE_COLUMN';
export const FETCH_UPDATE_COLUMN = 'FETCH_UPDATE_COLUMN';
export const FETCH_DELETE_COLUMN = 'FETCH_DELETE_COLUMN';
export const FETCH_GET_ALL_COLUMNS = 'FETCH_GET_ALL_COLUMNS';
export const FETCH_UPDATE_COLUMN_ORDER = 'FETCH_UPDATE_COLUMN_ORDER';
export const FETCH_COLUMN_ORDER = 'FETCH_COLUMN_ORDER';
export const FETCH_ARCHIVE_TASKS_BY_COLUMN = 'FETCH_ARCHIVE_TASKS_BY_COLUMN';
export const FETCH_COMPLETE_TASKS_BY_COLUMN = 'FETCH_COMPLETE_TASKS_BY_COLUMN';
